import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { CARGO_ITEM_STATUS } from '../../../../config/constants';
import Modal from '../../../common/modal/Modal';
import CargoItemRefundModal from './CargoItemRefundModal';
import { postParcelRefundV2 } from '../../../../actions';

const RefundButton = ({ parcel, dispatchPostParcelRefund }) => {
  const [showModal, setShowModal] = React.useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleParcelRefund = (formValues) => {
    let newFormValues;

    if (formValues.returnItemsToClient) {
      newFormValues = {
        amount: formValues.amount,
        costCenterId: formValues.costCenterId.value,
        expenseTypeId: formValues.expenseTypeId.value,
        authorizedUserId: formValues.authorizerUserId.value,
        itemsIds: formValues.itemIds,
        description: formValues.description,
        returnItemsToClient: true,

        creditNoteMotive: formValues.creditNoteMotive,
        creditNoteMotiveDescription: formValues.creditNoteMotiveDescription,
      };
    } else {
      newFormValues = {
        itemsIds: formValues.itemIds,
        returnItemsToClient: false,
        amount: formValues.amount,

        creditNoteMotive: formValues.creditNoteMotive,
        creditNoteMotiveDescription: formValues.creditNoteMotiveDescription,
      };
    }

    dispatchPostParcelRefund(parcel.id, newFormValues);
  };

  const cargoItems = Array.isArray(parcel.cargoItemList)
    ? parcel.cargoItemList
    : [];

  if (
    !cargoItems.some(
      (item) =>
        item.status === CARGO_ITEM_STATUS.RECEIVED.value ||
        item.status === CARGO_ITEM_STATUS.IN_TEMPORAL_AGENCY.value,
    )
  ) {
    return null;
  }

  return (
    <Fragment>
      <Button color="primary" onClick={() => setShowModal(true)}>
        Devolución
      </Button>
      <Modal
        show={showModal}
        title="Devolución de encomiendas"
        body={
          <CargoItemRefundModal
            parcel={parcel}
            onSubmit={handleParcelRefund}
            onCancel={handleCloseModal}
          />
        }
        size="xl"
      />
    </Fragment>
  );
};

RefundButton.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  parcel: PropTypes.object.isRequired,
  dispatchPostParcelRefund: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostParcelRefund: postParcelRefundV2,
};

export default connect(null, mapDispatchToProps)(RefundButton);
